import { render, staticRenderFns } from "./PrizeTable.vue?vue&type=template&id=230078ba&scoped=true&"
import script from "./PrizeTable.vue?vue&type=script&lang=js&"
export * from "./PrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./PrizeTable.vue?vue&type=style&index=0&id=230078ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230078ba",
  null
  
)

export default component.exports